module.exports = __webpack_public_path__ + "images/c481f74b.png";